import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as MUIButton } from '@mui/material';

interface ButtonProps {
  isActive: boolean;
  onClick: () => void;
}

const Button: FC<ButtonProps> = ({ isActive, onClick }) => {
  const { t } = useTranslation();

  return (
    <MUIButton
      sx={{
        height: { xs: '34px', md: '50px ' },
        textTransform: 'inherit',
        width: '100%',
        borderRadius: '6px',
        color: isActive ? 'primary.contrastText' : 'primary.main',
        fontSize: { xs: '14px', md: '20px' },
        lineHeight: { xs: '16px', md: '23px' },
        fontWeight: '300',
        border: '2px solid',
        '&:hover': {
          border: '2px solid',
          borderColor: isActive ? 'transparent' : 'primary.main',
        },
        borderColor: 'primary.main',
        whiteSpace: 'nowrap',
        boxShadow: 'none',
      }}
      variant={isActive ? 'contained' : 'outlined'}
      onClick={onClick}
    >
      {isActive ? t('cancel') : t('apply')}
    </MUIButton>
  );
};

export default Button;
